import { render, staticRenderFns } from "./approve-modal.vue?vue&type=template&id=23da03c0&scoped=true"
import script from "./approve-modal.vue?vue&type=script&lang=js"
export * from "./approve-modal.vue?vue&type=script&lang=js"
import style0 from "./approve-modal.vue?vue&type=style&index=0&id=23da03c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da03c0",
  null
  
)

export default component.exports